// extracted by mini-css-extract-plugin
module.exports = {"containerHome":"Home_containerHome__3pMfE"};